import { AfterViewInit, Component, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { LoggingService } from '../../../shared/services/logging';
@Component({
    selector: 'ef-send-hours-filter',
    templateUrl: './send-hours-filter.component.html',
    styleUrls: ['./send-hours-filter.component.scss'],
    standalone: false
})
export class SendHoursFilterComponent implements AfterViewInit {
    public moment: any = moment;
    public filterFormGroup: UntypedFormGroup;
    @Input() SendDocumentation: boolean;
    @Input() public set StartDate(value: Date) {
        this.filterFormGroup.controls.StartDate.setValue(value);
    }
    @Input() public set EndDate(value: Date) {
        this.filterFormGroup.controls.EndDate.setValue(value);
    }
    @Output() public SetSendDocumentation = new ReplaySubject<boolean>(1);
    @Output() public Filter = new ReplaySubject<{
        StartDate: Date;
        EndDate: Date;
        Resend: boolean;
    }>(1);
    constructor(private log: LoggingService) {
        this.filterFormGroup = new UntypedFormGroup({
            StartDate: new UntypedFormControl(null),
            EndDate: new UntypedFormControl(null),
            Resend: new UntypedFormControl(false)
        });
        this.filterFormGroup.valueChanges.subscribe(value => {
            this.log.verbose({
                type: 'SendHoursFilterComponent:filterFormGroup:valueChanges',
                value
            });
            if (
                value.StartDate &&
                value.EndDate &&
                moment(value.StartDate).isSameOrBefore(value.EndDate)
            ) {
                this.Filter.next({
                    ...value,
                    StartDate: moment(value.StartDate).toDate(),
                    EndDate: moment(value.EndDate).toDate()
                });
            }
        });
    }
    ngAfterViewInit(): void {}
}
